import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const DataIOMonitor = () => {
	return <PlaceholderView pageType={PageType.DataIOMonitor} text="Monitor" />;
};

export default DataIOMonitor;
